import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { UploadProvider } from './context/UploadContext';
import { Chart, registerables } from 'chart.js';
import streamSaver from 'streamsaver';

Chart.register(...registerables);

if (typeof window !== 'undefined') {
  streamSaver.mitm = `${window.location.origin}/stream-saver/mitm.html`;
  window.streamSaver = streamSaver;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UploadProvider>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </UploadProvider>
  </React.StrictMode>
);
